import React from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/shared/components/molecules/Dialog/dialog'

interface ZoneGrowModalProps {
	visible: boolean
	onClose: () => void
	onContactMe: () => void
	isRequestingUpgrade: boolean
}

const ZoneGrowModal: React.FC<ZoneGrowModalProps> = ({
	visible,
	onClose,
	onContactMe,
	isRequestingUpgrade,
}) => {
	const { t } = useTranslation('common')

	const handleOpenChange = (open: boolean) => {
		if (!open && !isRequestingUpgrade) {
			onClose()
		}
	}

	return (
		<Dialog open={visible} onOpenChange={handleOpenChange}>
			<DialogContent
				className="sm:max-w-[500px]"
				showCloseButton={!isRequestingUpgrade}
			>
				<DialogHeader>
					<DialogTitle>{t('entities.zone.grow.title')}</DialogTitle>
				</DialogHeader>

				<div className="py-4">
					<p className="text-sm text-muted-foreground">
						{t('entities.zone.grow.description')}
					</p>
				</div>

				<DialogFooter>
					<Button
						variant="outline"
						onClick={onClose}
						disabled={isRequestingUpgrade}
					>
						{t('actions.back')}
					</Button>
					<Button
						variant="default"
						onClick={onContactMe}
						disabled={isRequestingUpgrade}
					>
						{t('actions.contact_me')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}

export default ZoneGrowModal
